import { createRoute } from './createRoute';

const ROUTES_TEMPLATES = {
  transfer: '/transfer/:id',
  transferCanceled: '/transfer/:id/canceled',
  transferSearch: '/transfer/:id/search',
  transferInvoice: '/transfer/:id/invoice',
  transferBank: '/transfer/:id/:bankId',
  disputePayment: '/dispute_payment',
  serverError: '/server-error',
  notFoundError: '/not-found-error',
  redirect: '/redirect.html',
  mspPage: '/msp/:id',
  proofPage: '/proof/:id',
} as const;

export const routes = {
  transfer: createRoute(ROUTES_TEMPLATES.transfer),
  transferCanceled: createRoute(ROUTES_TEMPLATES.transferCanceled),
  transferSearch: createRoute(ROUTES_TEMPLATES.transferSearch),
  transferInvoice: createRoute(ROUTES_TEMPLATES.transferInvoice),
  transferBank: createRoute(ROUTES_TEMPLATES.transferBank),
  disputePayment: createRoute(ROUTES_TEMPLATES.disputePayment),
  serverError: createRoute(ROUTES_TEMPLATES.serverError),
  notFoundError: createRoute(ROUTES_TEMPLATES.notFoundError),
  redirect: createRoute(ROUTES_TEMPLATES.redirect),
  mspPage: createRoute(ROUTES_TEMPLATES.mspPage),
  proofPage: createRoute(ROUTES_TEMPLATES.proofPage),
};
